module.exports = __webpack_public_path__ + "static/media/hospitalDefault.1f4b13cd.png";